// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Select_wrap__RUOP6","select":"Select_select__2gUDO","icon":"Select_icon__1NBJN"};